import { Api } from "@jcd-web/basic-api";
export class CountryApi extends Api {
    static getAllActive() {
        return CountryApi.client.get("/");
    }
}
CountryApi.baseUrl = "/api/countries/";
